import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import Button from "@atlaskit/button/standard-button";
import { B300, N0, N500 } from "@atlaskit/theme/colors";

import { GmailLogo, OutlookLogo } from "../email-logos";

const overallContainerStyle = css({ display: "inline-flex", gap: "1rem" });

const socialButtonStyles = css({
    "alignItems": "center",
    "backgroundColor": `${N0}`,
    "border": `1px solid ${B300}`,
    "borderRadius": "3px",
    "boxSizing": "border-box",
    "display": "inline-flex",
    "gap": "0 0.75rem",
    "justifyContent": "center",
    "margin": "0 0 1rem",

    "&:focus": {
        backgroundColor: "#f9fafc",
        color: `${N500} !important`
    },
    "&:hover": {
        backgroundColor: "#f9fafc",
        color: `${N500} !important`
    },

    "&:focus-visible": {
        outlineOffset: "1px"
    },
    "svg": {
        display: "block",
        width: "1.5rem",
        height: "1.5rem",
        paddingInlineEnd: "0.5rem",
        alignSelf: "center"
    },
    ".buttonText": {
        display: "inline-flex",
        fontWeight: "normal"
    }
});

const CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES = {
    OPEN_GMAIL_CLICKED: "check_email_page_open_gmail_clicked",
    OPEN_OUTLOOK_CLICKED: "check_email_page_open_outlook_clicked"
};

export const EmailButtons = () => {
    const intl = useIntl();
    const openGmail = intl.formatMessage({
        id: "checkemail.openGmail",
        defaultMessage: "Open Gmail"
    });
    const openOutlook = intl.formatMessage({
        id: "checkemail.openOutlook",
        defaultMessage: "Open Outlook"
    });

    return (
        <section>
            <div css={overallContainerStyle}>
                <div css={socialButtonStyles}>
                    <Button
                        appearance={"link"}
                        data-event-component={"linkButton"}
                        data-event-container={"gmailButton"}
                        data-event={"clicked"}
                        data-product-key={"checkEmail"}
                        data-name={
                            CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_GMAIL_CLICKED
                        }
                        href={
                            "https://mail.google.com/mail/u/0/#search/atlassian+from%3A(%40atlassian.com)+in%3Aanywhere"
                        }
                    >
                        <div className={"buttonText"}>
                            <GmailLogo />
                            {openGmail}
                        </div>
                    </Button>
                </div>
                <div css={socialButtonStyles}>
                    <Button
                        appearance={"link"}
                        href={"https://outlook.live.com/mail/0/inbox"}
                        data-event-component={"linkButton"}
                        data-event-container={"outlookButton"}
                        data-event={"clicked"}
                        data-product-key={"checkEmail"}
                        data-name={
                            CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_OUTLOOK_CLICKED
                        }
                    >
                        <div className={"buttonText"}>
                            <OutlookLogo />
                            {openOutlook}
                        </div>
                    </Button>
                </div>
            </div>
        </section>
    );
};
